<template>
  <div>
    <span class="text-white text-zt-xs">{{ total }}</span>
  </div>
</template>

<script>
export default {
  name: 'UnsignedChip',
  props: ['total']
}
</script>

<style lang="scss" scoped></style>
